module.exports = __webpack_public_path__ + "img/shape-rectangle.d9c49e86.png";